// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IMedBenefitReplaceCardRequestModel {
    static getAttributeTypeMap() {
        return IMedBenefitReplaceCardRequestModel.attributeTypeMap;
    }
}
IMedBenefitReplaceCardRequestModel.discriminator = undefined;
IMedBenefitReplaceCardRequestModel.additionalProperties = false;
IMedBenefitReplaceCardRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
];
//# sourceMappingURL=iMedBenefitReplaceCardRequestModel.js.map